import React, { useState, useRef, useEffect } from "react";
import { MenuFoldOutlined, MenuUnfoldOutlined } from "@ant-design/icons";
import { Layout, Avatar, Grid } from "antd";
import Sidenav from "./Sidenav";
import Footer from "./Footer";
import DashboardHeader from "./DashboardHeader";
import nibssLogo from "../../assets/images/nibss-logo.svg";

const { Header, Sider, Content } = Layout;
const { useBreakpoint } = Grid;

const Main = ({ children }) => {
  const [collapsed, setCollapsed] = useState(false);
  const [sidenavColor, ,] = useState("#1A472B");
  const [sidenavType, ,] = useState("transparent");

  const screens = useBreakpoint();
  const refLogoImg = useRef(null);
  const refLogoLabel = useRef(null);

  const handleRef = () => {
    refLogoImg.current.style.width = collapsed ? "" : "400px";
    refLogoImg.current.style.height = collapsed ? "" : "40px";
    refLogoLabel.current.style.display = collapsed ? "" : "none";
  };

  useEffect(() => {

    const handleResize = () => {
      if (window.innerWidth < 768) {
        setCollapsed(true);
      } else {
        setCollapsed(false);
      }
    };

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <Layout style={{ background: "transparent" }}>
      <Header
        style={{
          background: "white",
          position: "sticky",
          top: 0,
          zIndex: 1,
          
        }}
      >
          <div className="brand header-dashboard-nibss">
        {/* <img src={logo} alt="" />
        <span>Muse Dashboard</span> */}

        <div className="header-col header-brand" ref={refLogoImg}>
          <img src={nibssLogo} alt="NIBSS LOGO" />
        </div>
        <h1 ref={refLogoLabel} className="nibss-bio-header-dashboard">
          BIOMETRIC CERTIFICATE ISSUANCE PORTAL
        </h1>
        {/* <div className="header-col header-btn">
              <Button type="primary header-btn-home">Sign In</Button>
            </div> */}
      </div>
        <div style={{ display: "flex" }}>
        
          {React.createElement(
            collapsed ? MenuUnfoldOutlined : MenuFoldOutlined,
            {
              className: "trigger",
              onClick: () => {
                handleRef();
                setCollapsed(!collapsed);
              },
            }
          )}
        
          <DashboardHeader />
        </div>
      </Header>
      <Layout>
      {screens.md && (
          <Sider
            trigger={null}
            collapsible
            collapsed={collapsed}
            width={screens.md ? 300 : 200}
            style={{ background: "transparent" }}
            theme="light"
            className={`sider-primary ant-layout-sider-primary margin ${
              sidenavType === "#fff" ? "active-route" : ""
            }`}
          >
            <Sidenav
              color={sidenavColor}
              refLogoImg={refLogoImg}
              refLogoLabel={refLogoLabel}
            />
          </Sider>
        )}
        <Layout>
          <Content
            style={{
              margin: screens.md ? "24px 16px" : "24px 8px",
              padding: screens.md ? 24 : 8,
            }}
          >
            {children}
          </Content>
        </Layout>
      </Layout>
      <Footer className="nibss-dashboard-footer" />
    </Layout>
  );
};

export default Main;
